import { apiGet, apiDelete, apiPostMultipart, apiPutMultipart } from 'helpers/ApiHelper';
import Auth from 'j-toker';
import * as notificationActions from './notificationActions';
import * as formatter from 'helpers/Formatter';

export function getEventDetails(siteEventType, siteEventId) {
  return (dispatch) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + `/landlords/site_event/${siteEventType}/${siteEventId}`)
        .done((response) => {
          dispatch(showEventDetails(response.site_event));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function showEventDetails(eventDetails) {
  if (eventDetails.start_date) {
    eventDetails.start_date = formatter.toDate(eventDetails.start_date);
  }
  if (eventDetails.end_date) {
    eventDetails.end_date = formatter.toDate(eventDetails.end_date);
  }

  if (eventDetails.post_date) {
    eventDetails.post_date = formatter.toDate(eventDetails.post_date);
  }
  return {
    type: 'LANDLORD_SITE_EVENTS::SHOW_EVENT_DETAILS',
    eventDetails,
  };
}

export function getEvents(propertyIds, range = null) {
  let formattedRange = null;
  if (range && Array.isArray(range)) {
    formattedRange = {
      start_date: formatter.toISO8601DateString(range[0]),
      end_date: formatter.toISO8601DateString(range[range.length - 1]),
    };
  } else if (range && range.start) {
    formattedRange = {
      start_date: formatter.toISO8601DateString(range.start),
      end_date: formatter.toISO8601DateString(range.end),
    };
  }

  let options = {
    property_ids: propertyIds,
    ...formattedRange,
  };
  return (dispatch) => {
    return dispatch({
      payload: apiGet(
        Auth.getApiUrl() + '/landlords/site_events' + formatter.objectToQuery(options)
      )
        .done((response) => {
          dispatch(showEvents(response.site_events));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function showEvents(siteEvents) {
  return {
    type: 'LANDLORD_SITE_EVENTS::SHOW_EVENTS',
    siteEvents,
  };
}

export function clearEventDetails() {
  return {
    type: 'LANDLORD_SITE_EVENTS::SHOW_EVENT_DETAILS',
    eventDetails: {},
  };
}

export function clearEvents() {
  return {
    type: 'LANDLORD_SITE_EVENTS::SHOW_EVENTS',
    siteEvents: [],
  };
}

export function createOrUpdateEvent(data, siteEventId = null) {
  return (dispatch) => {
    const multiPartFormData = new FormData();

    if (data.photo[0] instanceof File) {
      multiPartFormData.append('photo', data.photo[0]);
    }

    data['property_ids'] = data['properties'].map((property) => {
      return property.value;
    });

    data['start_date'] = formatter.toISO8601DateTimeString(data['start_date']);
    data['end_date'] = formatter.toISO8601DateTimeString(data['end_date']);
    data['post_date'] = formatter.toISO8601DateTimeString(data['post_date']);

    const formData = JSON.stringify(data);
    multiPartFormData.append('data', formData);

    let successCode = 'siteEventSuccessfullyCreated';
    if (siteEventId) {
      successCode = 'siteEventSuccessfullyUpdated';
    }

    return dispatch({
      payload: siteEventPayload(siteEventId, multiPartFormData)
        .done((response) => {
          dispatch(notificationActions.showSuccess(successCode));
        })
        .catch((error) => {
          if (error.responseJSON && error.responseJSON.error_code) {
            dispatch(notificationActions.showFailure(error.responseJSON.error_code));
          } else {
            dispatch(notificationActions.showFailure(error));
          }
          console.error('request failed', error);
        }),
    });
  };
}

function siteEventPayload(siteEventId, multiPartFormData) {
  if (siteEventId) {
    return apiPutMultipart(
      Auth.getApiUrl() + `/landlords/site_events/${siteEventId}`,
      multiPartFormData
    );
  } else {
    return apiPostMultipart(Auth.getApiUrl() + '/landlords/site_events', multiPartFormData);
  }
}

export function deleteSiteEvent(siteEventType, siteEventId) {
  return (dispatch) => {
    return dispatch({
      payload: apiDelete(
        Auth.getApiUrl() + `/landlords/site_events/${siteEventType}/${siteEventId}`
      )
        .done((response) => {
          dispatch(notificationActions.showSuccess('siteEventSuccessfullyDeleted'));
        })
        .catch((error, textStatus) => {
          dispatch(notificationActions.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}
